
import mission from "../../images/aboutUsImages/mission.svg";
import vision from "../../images/aboutUsImages/vision.svg";


export default {
    missionVision : [
        {
          title: "Vision",
          imgIcon: vision,
          content:
            "Netcom is to provide ubiquitous, secure and seamless access to information resources in all forms through reliable and robust infrastructure.To build better solution for education industry through AI and machine learning capabilities in many areas of space operations to enable people to empower the knowledge of the application of education.",
        },
        {
          title: "Mission",
          imgIcon: mission,
          content:
            "To provide best of breed software products to enable organization to run their businesss and operations better.To deliver effective IT solution and quality services.To enchance the competitive advantages of our clients.To maintain a sustainable social environment and be a socially responsible corporate citizen.",
        },
      ],
      whatWeDo:"Netcom Computers has a team of working with many fields of IT industry. We have strong foothold in a variety of fields like computer education, computer aided education, soft skill training, software solutions, web solutions, 3D and 2D animations, cartoon animations, etc.,"
   
  }
 